import { render } from "./CommonContribute.vue?vue&type=template&id=428c9722"
import script from "./CommonContribute.vue?vue&type=script&lang=js"
export * from "./CommonContribute.vue?vue&type=script&lang=js"

import "./CommonContribute.vue?vue&type=style&index=0&id=428c9722&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__